<template>
  <div>
    <HeaderOfPage :bgSrc="'shopping.jpg'" :titleOfPage="'التسويق والترفيه'" :theDiscription="'تسويق وترفيه'"/>
    <section class="pages-container">
      <ShoppingContent/>
    </section>
  </div>
</template>
<script type="text/javascript">
  import HeaderOfPage    from '../global/HeaderOfPage';
  import ShoppingContent from './ShoppingContent'
  export default {
    name:'Shopping',
    components: {HeaderOfPage,ShoppingContent}
  }
</script>
